import VirusQuestions from "./VirusQuestions";
export default VirusQuestions;
